export const sizeTheme = {
    media:{
        m:'(max-width: 992px)'
    },
}